import { AnalysisSettings } from 'features/analysis/types'

export enum TradeAreasMode {
  Car = 'car',
  Walk = 'walk'
}

export enum TradeAreasType {
  Distance = 'distance',
  Time = 'time'
}

export interface TradeAreasSettings extends AnalysisSettings {
  mode: TradeAreasMode
  type: TradeAreasType
  distance?: number
  time?: number
}
